export default function (obj) {
  const ret = [];
  for (const key in obj) {
    ret.push({ value: Number(key), title: obj[key] });
  }
  return ret;
}
